import React, { useState } from 'react';
import '../../css/Admin/AdminLogin.css';
import { useNavigate } from 'react-router-dom';
import Logo from '../../assets/logo.png';
import ResponseMsg2 from '../../general/ResponseMsg2';
import { SiGoogletagmanager } from 'react-icons/si';

const TeacherLogin = ({ setLoading }) => {
  const [formData, setFormData] = useState({
    id: '',
    pass: '',
  })
  // const [response, setResponse] = useState({ message: '', status: 'success' });
  const [response2, setResponse2] = useState({ message: '', status: 'success' });


  const navigate = useNavigate();

  // Handle form data change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };


  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch('https://api.kcian.in/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: formData.id,
          pass: formData.pass,
        }),
      });

      const data = await res.json();

      if (res.ok) {

        if ( data[0].role !== 'Teacher' && data[0].role !== 'Librarian' && data[0].role !== 'Transport' ) {
          setResponse2({ message: 'Account does not belongs to this Panel.', status: 'error' });
          setTimeout(() => setResponse2({ message: '', status: '' }), 2000);
        }
        else {
          localStorage.setItem('userData', JSON.stringify(data));

          localStorage.setItem('isInsAdmin', 'true');
          setResponse2({ message: 'Staff Login Success!', status: 'success' });
          setTimeout(() => {
            setResponse2({ message: '', status: '' });
            navigate('/admin/dashboard');
          }, 2000);
        }
      } else {
        setResponse2({ message: data.message || 'Incorrect Credentials', status: 'error' });
        setTimeout(() => setResponse2({ message: '', status: '' }), 2000);
      }
    } catch (error) {
      // console.error('Login error:', error);
      setResponse2({ message: 'Server error. Please try again.', status: 'error' });
      setTimeout(() => setResponse2({ message: '', status: '' }), 2000);
    } finally {
      setLoading(false);
    }
  };



  return (
    <>

      <section className='admin-outer'>
        <div className='admin-inner'>

          <div className='row bg-light rounded-4'>

            <div className='col-lg-7 col-12 px-0'>
              <div className='admin-left rounded-start-4'>
                <img src={Logo} className='ins-logo bg-light rounded-circle' alt='Logo' />

                <p className='admin-heading mt-3 mb-md-5'>School Management System</p>

                <div className='row'>

                  <div className='col-md-4 col-sm-4 col-12 my-2 d-md-block d-sm-block d-none'>
                    <div className='admin-card'>
                      {/* <i class="fa-solid fa-code fs-1" style={{color: '#4A9782'}}></i> */}
                      <SiGoogletagmanager color='#4A9782' size={45} />
                      <p className='fw-bold mt-3'>Easy Class Management</p>
                    </div>
                  </div>

                  <div className='col-md-4 col-sm-4 col-12 my-2 d-md-block d-sm-block d-none'>
                    <div className='admin-card'>
                      <i class="fa-solid fa-user-gear fs-1" style={{ color: '#FFCB61' }}></i>
                      <p className='fw-bold mt-3'>Smart Timetable Allocation</p>
                    </div>
                  </div>

                  <div className='col-md-4 col-sm-4 col-12 my-2 d-md-block d-sm-block d-none'>
                    <div className='admin-card'>
                      <i class="fa-solid fa-user-tie fs-1" style={{ color: '#456882' }}></i>
                      <p className='fw-bold mt-3'>Teacher-Friendly Interface</p>
                    </div>
                  </div>

                </div>
                {/* inner row ends */}

              </div>
            </div>

            <div className='col-lg-5 col-12 bg-light align-content-center rounded-end-4'>
              <form class="row g-3 mt-4 px-md-4 px-2 pb-5" onSubmit={handleLogin}>

                {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}

                <div class="col-12 login-input-area px-3 pt-2">
                  <label className='login-label fw-semibold'>Staff Id</label>
                  <input type="text" class="login-input-control" id="inputMobile4" name='id' onChange={handleChange} value={formData.id} />
                </div>
                <div class="col-12 login-input-area px-3 pt-2">
                  <label className='login-label fw-semibold'>Password</label>
                  <input type="password" class="login-input-control" id="inputPassword4" name='pass' onChange={handleChange} value={formData.pass} />
                </div>
                <div class="col-12 mt-4 text-center">
                  <button type="submit" class="login-btn2">Login</button>
                </div>
              </form>
            </div>

          </div>
          {/* row ends */}

        </div>
      </section>

    </>
  )
}

export default TeacherLogin
